module.exports = __webpack_public_path__ + "static/media/abp.d4150c90.jpg";